<template>
  <div class="call-to-action">
    <div class="main-container">
      <div class="info-container" v-scroll-animate>
        <slot name="info-box"></slot>
      </div>
      <div class="asset-container">
        <slot name="image-box"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import SeuButton from "/seu-frontend/components/SeuButton";

export default {
  name: 'CallToAction',
  components: {SeuButton},
  props: {
    field: {
      type: Object
    }
  }

}
</script>

<style lang="scss">
@import "CallToAction.scss";
</style>
